import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Page } from '../../interfaces/Page/Page';
import { getPages } from '../../api/Page';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { PagesTable } from './PagesTable';

export const PagesPage = () => {
  const navigate = useNavigate();

  const [pages, setPages] = useState<Page[]>([]);
  const [loading, setLoading] = useState(false);

  const refreshPages = () => {
    setLoading(true);
    getPages()
      .then((p) => setPages(p))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(refreshPages, []);

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Sayfalar
      </Typography>
      <Waiting open={loading} />
      <Button
        variant='contained'
        startIcon={<AddIcon />}
        onClick={() => navigate('/pages/pages/new')}
        sx={{ ...sharedStyles.buttonText, mb: 1.5 }}
      >
        Yeni Sayfa
      </Button>
      <PagesTable pages={pages} />
    </Box>
  );
};
